import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getPurchaseCreditNoteNumber(cookies, plantId, cnDate) {
    const url = `${apiBaseUrl}/purchase_credit_notes/purchase_credit_note_number/?plant_id=${plantId}&cn_date=${cnDate}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getPurchaseCreditNotes(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/purchase_credit_notes/${query ? `?${query}` : ''}`).then((r) => r.data);
}

export async function getPurchaseCreditNoteDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/purchase_credit_notes/${id}/`).then((r) => r.data);
}

export async function printPurchaseCreditNote(cookies, noteId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/purchase_credit_notes/${noteId}/print_purchase_credit_note/`, {
        responseType: 'blob',
    }).then((response) => response.data);
}

export async function getGrnsForPurchaseNote(cookies, plantId, vendorId) {
    const url = `${apiBaseUrl}/purchase_credit_notes/grns_for_vendor/?plant_id=${plantId}&vendor_id=${vendorId}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getPurchaseCreditNoteGrnContext(cookies, gmrId, excludeCnId = '') {
    let url = `${apiBaseUrl}/purchase_credit_notes/grn_context/?gmr_id=${gmrId}`;
    if (excludeCnId) url += `&exclude_cn_id=${excludeCnId}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export function createPurchaseCreditNote(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/purchase_credit_notes/`, payload).then((r) => r.data);
}

export function cancelPurchaseCreditNote(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/purchase_credit_notes/${id}/`, {}).then((r) => r.data);
}

export function deletePurchaseCreditNote(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/purchase_credit_notes/${id}/`).then((r) => r.data);
}
